module.exports = __webpack_public_path__ + "img/chadle2_4.882f72b7.png";